module.exports = __webpack_public_path__ + "img/copy-icon-blue.c02e38af.svg";